var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankyouIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "274px",
    height: "274px",
    viewBox: "0 0 274 274",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "83B50354-4C35-47CA-A149-78A10429340E@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shopping-Cart-Dialog-Box",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discover---No-Item-in-collection-Copy",
    transform: "translate(-584.000000, -243.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(584.000000, 243.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C6E5F7",
    opacity: 0.373093378,
    cx: 137,
    cy: 137,
    r: 137
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C6E5F7",
    opacity: 0.373093378,
    cx: 137,
    cy: 137,
    r: 97.9810127
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(82.373418, 78.037975)",
    fill: "#75C3F3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "43.1622438 79.9771121 22.0411928 58.2091768 14.8488924 65.5695578 43.1622438 94.7500753 103.942247 32.108535 96.8005965 24.748154"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyouIcon);
export default __webpack_public_path__ + "static/media/thankyou_icon.c83ece3640a7479f7a7299bcbfd8be93.svg";
export { ForwardRef as ReactComponent };